export default __webpack_public_path__ + "static/typography-image-u-cda032f4eea0c9c0746125dc705aa1b4ced0369b5fbed2dc1b949ce519397ff1.png";